<script>
import appConfig from '@/app.config'
import WebviewAudioItem from './Webview/WebviewAudioItem.vue';

export default {
  name: 'WebviewAudioCall',
  page: {
    title: 'AudioCall',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    WebviewAudioItem,
  },
}
</script>

<template>
  <WebviewAudioItem />
</template>
